module.exports = __webpack_public_path__ + "img/coupon-2-line.e3decc36.svg";